import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, Terminal } from "lucide-react";
import { SettingsDrawer } from "./SettingsDrawer";

export function TopBar() {
  const [settingsOpen, setSettingsOpen] = useState(false);
  const location = useLocation();

  // Very short breadcrumb trail derived from pathname
  const segments = location.pathname.split("/").filter(Boolean);

  return (
    <header className="sticky top-0 z-30 bg-ink-950/85 backdrop-blur-md border-b border-ink-800">
      <div className="mx-auto max-w-7xl px-6 py-3.5 flex items-center gap-6">
        <Link to="/" className="group flex items-center gap-2.5">
          <div className="w-7 h-7 bg-phosphor-400 text-ink-950 flex items-center justify-center font-bold text-sm shadow-[0_0_12px_rgba(229,166,99,0.35)]">
            <Terminal size={15} strokeWidth={2.5} />
          </div>
          <div className="flex items-baseline gap-1">
            <span className="font-serif text-xl italic text-ink-100 group-hover:text-phosphor-300 transition-colors">
              simdb
            </span>
            <span className="text-ink-500 text-xs">/</span>
            <span className="text-xs uppercase tracking-[0.2em] text-ink-300">
              console
            </span>
          </div>
        </Link>

        <nav className="hidden sm:flex items-center gap-1 text-[11px] font-mono text-ink-500">
          <span className="text-ink-600">~</span>
          {segments.length === 0 ? (
            <span className="text-phosphor-400">/</span>
          ) : (
            segments.map((s, i) => (
              <span key={i} className="flex items-center gap-1">
                <span className="text-ink-600">/</span>
                <span
                  className={
                    i === segments.length - 1
                      ? "text-phosphor-400"
                      : "text-ink-400"
                  }
                >
                  {s.length > 16 ? s.slice(0, 10) + "…" : s}
                </span>
              </span>
            ))
          )}
          <span className="text-phosphor-400 animate-blink ml-0.5">_</span>
        </nav>

        <div className="ml-auto flex items-center gap-3">
          <div className="hidden md:flex items-center gap-2 text-[10px] uppercase tracking-widest text-ink-500">
            <span className="w-1.5 h-1.5 bg-signal-400 shadow-[0_0_6px_var(--color-signal-500)]" />
            online
          </div>
          <button
            type="button"
            onClick={() => setSettingsOpen(true)}
            className="btn !px-3 !py-2"
            aria-label="Open settings"
          >
            <Menu size={14} />
          </button>
        </div>
      </div>
      <SettingsDrawer open={settingsOpen} onClose={() => setSettingsOpen(false)} />
    </header>
  );
}
